import React, { useEffect, useState, useCallback, useMemo } from "react";
import Reflux from "reflux";
import { withRouter } from "react-router-dom";
import * as SC from "./CampaignCreatePreviews.styled";
import { CSSTransition } from "react-transition-group";
import { useTranslation } from "react-i18next";

import { PosthogStore } from "@talentbait/shared-components";

import TemplatePostActions from "../TemplatePost/TemplatePostActions";

import SideBarChannels from "../SideBarChannels";
import CampaignCreatePostSelector from "../Campaign__Create_PostSelector";
import CampaignCreatePostEditor from "../campaign-create-post-editor/CampaignCreatePostEditor";
import { Switch } from "../Components";
import Actions from "../../../../Actions";
import { ActionsTempDraftCreation } from "../../../../Actions/ActionsTempDraftCreation/ActionsTempDraftCreation";
import {
  withRefluxStore,
  PreviewStore,
  MediaAssetsLabStore,
  TempDraftCreationStore,
  CampaignCreationStore
} from "../../../../Stores";
import { WebIcon, MobileIcon, SharePreviewIcon, SaveIcon } from "../Svg";
import CampaignCreateStartDateEditor from "../Campaign__Create_StartDateEditor";
import logger from "../../../../utils/LoggerFrontend.js";
import JobPageStore from "../PostEditors/JobPage/JobPageStore";
import JobPageActions from "../PostEditors/JobPage/JobPageActions";
import useDisableContextMenu from "../../../../hooks/useDisableContextMenu";
import PostEditorSkeleton from "../PostEditors/post-editor-skeleton/PostEditorSkeleton";
import Loader from "../Loader";
import { useFlags, withLDConsumer } from "launchdarkly-react-client-sdk";
import { useLogoRequired } from "../../campaign-creation/hooks/useLogoRequired";
import PrintAdpreview from "../../print-views/print-adpreview/PrintAdpreview";
import { ActionsMediaAssetsLab } from "../../../../Actions/ActionsMediaAssetsLab/ActionsMediaAssetsLab";
import { Button } from "../../../../Components/Button";
import { ExpandIcon, PdfFileIcon } from "../../../../Components/Icons";
import MediaAssetsLab from "../media-assets-lab/MediaAssetsLab";
import { useCampaignContext } from "../../../../context/Campaign.context.jsx";
import { getLanguageFromLocale } from "../../QualificationQuestions/utils";
import { CAMPAIGN_IS_BOOKED } from "../constants.js";
import { usePrint } from "../../../../hooks/use-print.hook.js";

Reflux.initStore(JobPageStore);
Reflux.initStore(PreviewStore);

const ORGAS_WITH_LINK_TO_PREVIEW = [
  "fEjYdchvwrh8cEQLfVK1",
  "DmYt6NNRbeOD9gTu73Ln",
  "-L6I5I1-AWF6HX4VJ_9l",
  "ZmPQi4UDm6nxDNNDLTPf",
  "5SO0AufyBg4OWkF6ju1y",
  "IvDNu0PsPuLv9bvZyywt"
];

const CampaignCreatePreviews = ({
  children,
  isExternal = false,
  isReleased,
  editable = true,
  secondsLeft,
  showStartingDatePanel,
  setSecondsLeft,
  startingDate,
  changeStartingDate,
  setCampaignWaitingForApproval,
  orgaId,
  tbCampaignId,
  clientView = true,
  hasAts,
  showLinkEditor,
  preselectedChannelPreview = "",
  orgaLinkedInPageID,
  // Store
  jobPageLink,
  selectedPostNumber,
  posthogInstance,
  loading,
  posts: stagingPosts,
  tbAdsetId,
  channelsData: stagingChannelData,
  released,
  userProfile,
  allowMultiplePostsPerChannel,
  maxPostPerChannel,
  companyLogo,
  adErrors,
  showMediaAssetsLabModal,
  templateDataToDownload,
  // Router
  history,
  locale,
  campaignData
}) => {
  const { selectedChannels, setSelectedChannels } = useCampaignContext();

  const printCallbackFn = () => {
    Actions.logCampaignActivity(tbCampaignId, {
      message: `Downloaded Ad Preview`,
      type: "Change",
      orgaId,
      date: new Date().toISOString(),
      userName: userProfile.userName
    });
  };

  const { contentRef, isPrinting, handlePrint } = usePrint(printCallbackFn);

  const lang = CAMPAIGN_IS_BOOKED.includes(campaignData?.status) ? campaignData?.locale : locale;
  const campaignLanguage = getLanguageFromLocale(lang || "de_DE");

  const { checkLogoRequired } = useLogoRequired();
  const [logosChecked, setLogosChecked] = useState(false);
  const { campaignCreationMediaAssets = false } = useFlags();

  const { t } = useTranslation();

  // Get posts and channelsData based on isReleased
  const [channelCampaignMapping, setChannelCampaignMapping] = useState([]);

  // Disable context menu to avoid the clients download the images
  useDisableContextMenu(userProfile);

  logger.debug("CampaignCreatePreview:init", "channelCampaignMapping", {
    channelCampaignMapping,
    campaignId: tbCampaignId
  });

  //Mount
  useEffect(() => {
    return () => {
      setLogosChecked(false);
    };
  }, []);

  useEffect(() => {
    ActionsTempDraftCreation.changeTempDraftCampaignId(tbCampaignId);
  }, [tbCampaignId]);

  const { posts, channelsData } = useMemo(
    () => (isReleased ? released : { posts: stagingPosts, channelsData: stagingChannelData }),
    [isReleased, released, stagingChannelData, stagingPosts]
  );

  // Selected channels from the budget step (sorted)
  const selectedChannelsFromBudget = useMemo(
    () => Object.keys(channelsData || {}).sort(),
    [channelsData]
  );

  useEffect(() => {
    if (JSON.stringify(selectedChannels) !== JSON.stringify(selectedChannelsFromBudget)) {
      setSelectedChannels(selectedChannelsFromBudget);
    }
  }, [selectedChannels, selectedChannelsFromBudget, setSelectedChannels]);

  const [isMobileView, setIsMobileView] = useState(false);
  const [selectedPreviewChannel, setSelectedPreviewChannel] = useState(
    selectedChannels.includes(preselectedChannelPreview)
      ? preselectedChannelPreview
      : selectedChannels[0]
  );
  const [selectedCreativeIndexToEdit, setSelectedCreativeIndexToEdit] = useState(0);
  const [editableChannelData, setEditableChannelData] = useState(null);
  const [showAts, setShowAts] = useState(false);
  const [showLeadForm, setShowLeadForm] = useState(false);

  const [isGeneratingMedia, setIsGeneratingMedia] = useState(false);

  // Get selected post by selected channel and post number
  const selectedPost = useMemo(
    () =>
      selectedPostNumber &&
      (posts?.[selectedPreviewChannel] || []).find(
        (post) => post.postNumber === selectedPostNumber
      ),
    [selectedPostNumber, selectedPreviewChannel, posts]
  );

  useEffect(() => {
    if (selectedPreviewChannel === "tiktok") {
      TemplatePostActions.updateTemplateType({ templateType: "video", isTikTokVideo: true });
    } else {
      TemplatePostActions.updateTemplateType({ templateType: "image" });
    }
  }, [selectedPreviewChannel]);

  const setSelectedPostNumber = useCallback((newPostNumber) => {
    Actions.updateSelectedPostNumber(newPostNumber);
  }, []);

  // Auto select a preview channel for preview if no available channel is selected
  useEffect(() => {
    if (
      !loading &&
      selectedChannels.length &&
      (!selectedPreviewChannel ||
        selectedChannels.findIndex((channel) => channel === selectedPreviewChannel) === -1)
    ) {
      setSelectedPreviewChannel(
        selectedChannels.includes(preselectedChannelPreview)
          ? preselectedChannelPreview
          : selectedChannels[0]
      );
    }
  }, [selectedChannels, loading, selectedPreviewChannel, preselectedChannelPreview]);

  // Auto select a post for preview if no available post is selected
  useEffect(() => {
    if (!selectedPost && posts && !loading) {
      setSelectedPostNumber(posts[selectedPreviewChannel]?.[0]?.postNumber);
    }
  }, [posts, selectedPost, selectedPreviewChannel, loading, setSelectedPostNumber]);

  useEffect(() => {
    if (!selectedPostNumber || !selectedPreviewChannel) return;

    const editableChannelData =
      channelsData[selectedPreviewChannel].find((channel) => {
        return channel.postNumber === selectedPostNumber;
      }) ?? channelsData[selectedPreviewChannel][0];

    setEditableChannelData(editableChannelData);
  }, [selectedPostNumber, selectedPreviewChannel]);

  // Fetch job page data so that we can update the header image whenever there are
  // changes to the creatives
  useEffect(() => {
    JobPageActions.getJobPage(tbCampaignId);
  }, [tbCampaignId]);

  // Get channel campaigns by campaignId
  useEffect(() => {
    logger.log(
      "CampaignCreatePreview:getChannelCampaignsByCampaignId",
      "Loaded channel campaigns for tbCampaignId",
      {
        campaignId: tbCampaignId,
        channelCampaignMapping
      }
    );
    // Register listener
    Actions.getChannelCampaignsByCampaignId.completed.listen((channelCampaigns) => {
      setChannelCampaignMapping(channelCampaigns);

      logger.log(
        "CampaignCreatePreview:getChannelCampaignsByCampaignId:completed",
        "Loaded channel campaigns for tbCampaignId",
        {
          campaignId: tbCampaignId,
          channelCampaigns,
          channelCampaignMapping
        }
      );
    });

    Actions.getChannelCampaignsByCampaignId(tbCampaignId);

    // Avoid to add channelCampaignMapping as dependency
    // it will cause an infinite loop due to the setChannelCampaignMapping
  }, [tbCampaignId]);

  // Switch between mobile and web view
  const switchPreviewMode = useCallback(() => {
    setIsMobileView((isMobile) => !isMobile);
  }, []);

  // Select another preview channel
  const changePreviewChannel = useCallback(
    (channel) => {
      logger.log("CampaignCreatePreview:changePreviewChannel", "called", {
        channel,
        showAts,
        showLeadForm,
        campaignId: tbCampaignId
      });

      if (channel === "tiktok") {
        TemplatePostActions.updateTemplateType({ templateType: "video", isTikTokVideo: true });
      }

      setSelectedPreviewChannel(channel);
      setSelectedPostNumber(posts[channel][0].postNumber);
      setSelectedCreativeIndexToEdit(0);

      setShowAts(false);
      setShowLeadForm(false);

      const params = new URLSearchParams(window.location.search);
      params.set("channel", channel);

      history.push({
        search: params.toString()
      });
    },
    [posts, history, setSelectedPostNumber]
  );

  // Handle switching to Qualification questions
  const switchToQualificationQuestions = () => {
    setShowAts(true);
    setShowLeadForm(false);
  };

  // Handle switching to Lead form
  const switchToLeadForm = () => {
    setShowAts(false);
    setShowLeadForm(true);
  };

  // Delete post
  const handleRemovePost = useCallback(
    ({ postId, postNumber }) => {
      Actions.removePost({
        channelShortName: selectedPreviewChannel,
        postId,
        postNumber,
        isReleased,
        userName: userProfile.userName,
        campaignId: tbCampaignId
      });
    },
    [selectedPreviewChannel, isReleased, userProfile?.userName, tbCampaignId]
  );

  const getAvailablePostNumber = useCallback(() => {
    let freeNumber = 1;
    posts[selectedPreviewChannel]
      .map((post) => post.postNumber)
      .sort((a, b) => a - b)
      .find((postNumber) => {
        if (postNumber === freeNumber) {
          freeNumber++;
          return false;
        } else {
          return true;
        }
      });
    return freeNumber;
  }, [posts, selectedPreviewChannel]);

  // Create new post
  const handleAddPost = useCallback(() => {
    const postNumber = getAvailablePostNumber();
    Actions.addPost({
      channelShortName: selectedPreviewChannel,
      postNumber,
      isReleased,
      campaignId: tbCampaignId,
      userName: userProfile.userName
    });
  }, [
    getAvailablePostNumber,
    selectedPreviewChannel,
    isReleased,
    userProfile?.userName,
    tbCampaignId
  ]);

  const generateMedia = useCallback(() => {
    setIsGeneratingMedia(true);

    let generateMediaFormat = [
      { inputProps: selectedPost.videoData, templateId: "TikTokVideo", type: "video" }
    ];

    if (templateDataToDownload) {
      generateMediaFormat = [{ ...templateDataToDownload, type: "video" }];
    }

    const ref = Actions.generateMedia.completed.listen((payload) => {
      logger.log(
        "TemplatePreviewSections:generateMediaClicked",
        "successfully called Image generator",
        {
          payload
        }
      );
      Actions.addNotification(t("Image generated"));
      setIsGeneratingMedia(false);

      const { imageResults, videoResults } = payload;
      imageResults.map(({ url }) => window.open(url, "_blank"));
      videoResults.map(({ url }) => window.open(url, "_blank"));
      ref();
    });

    const refFailed = Actions.generateMedia.failed.listen((error) => {
      logger.log(
        "error:TemplatePreviewSections:generateMediaClicked",
        "failed to call Image generator",
        {
          error
        }
      );
      setIsGeneratingMedia(false);
      Actions.addNotification(t("Unable to Generate Media"), "error");
      refFailed();
    });

    Actions.generateMedia(generateMediaFormat);
  }, [setIsGeneratingMedia, selectedPost, templateDataToDownload, t]);

  const handleCopyLink = useCallback(async () => {
    try {
      const ref = Actions.generateShareLinkForCampaign.completed.listen(({ payload }) => {
        const { shareUrl } = payload;
        navigator.clipboard.writeText(shareUrl);
        Actions.addNotification(t("Link to job advertisement copied"));
        ref();
      });

      const refFailed = Actions.generateShareLinkForCampaign.failed.listen((error) => {
        logger.error("CampaignCreatePreviews:handleCopyLink", "Error copying link", { error });
        Actions.addNotification(t("Error copying link"), "error");
        refFailed();
      });

      Actions.generateShareLinkForCampaign(tbCampaignId);
    } catch (error) {
      logger.error("CampaignCreatePreviews:handleCopyLink", "Error copying link", { error });
      Actions.addNotification(t("Error copying link"), "error");
    }
  }, [tbCampaignId, t]);

  // Show web and mobile switcher based on selected channel
  const showDeviceSwitch = useMemo(
    () =>
      !showAts &&
      !showLeadForm &&
      (selectedPreviewChannel === "facebook" || selectedPreviewChannel === "google-search"),
    [selectedPreviewChannel, showAts, showLeadForm]
  );

  const selectedChannelCampaignData = useMemo(() => {
    logger.debug("selectedChannelCampaignData", "channelCampaignMapping", {
      channelCampaignMapping,
      campaignId: tbCampaignId
    });

    // Get channel campaign for a specific channel
    const selectedChannelCampaigns = channelCampaignMapping
      .filter((cc) => cc.channel === selectedPreviewChannel)
      .sort((first, second) =>
        new Date(first.createdDate) < new Date(second.createdDate) ? 1 : -1
      );

    logger.debug("selectedChannelCampaignData", "filter ", {
      selectedChannelCampaigns,
      campaignId: tbCampaignId
    });

    // Retrieves all the ad creatives versions
    const channelCampaignVersions = selectedChannelCampaigns
      .map((cc) => cc.adCreativeVersion)
      .filter(Boolean);

    // Finds the latest ad creative version
    const latestVersion = Math.max(...channelCampaignVersions);

    logger.debug("selectedChannelCampaignData", "max version", {
      latestVersion,
      campaignId: tbCampaignId
    });

    // Gets all the latest channel campaign
    const latestChannelCampaign = selectedChannelCampaigns.filter(
      (cc) => cc.adCreativeVersion === latestVersion
    );

    logger.log("selectedChannelCampaignData", "selected channelCampaign", {
      latestChannelCampaign,
      campaignId: tbCampaignId
    });

    return latestChannelCampaign[0] || {};
  }, [channelCampaignMapping, selectedPreviewChannel, tbCampaignId]);

  useEffect(() => {
    if (campaignCreationMediaAssets && posts && !logosChecked) {
      checkExistingLogo();
      setLogosChecked(true);
    }

    if (posts) {
      checkSpotifyClipGenerator();
    }
  }, [posts, campaignCreationMediaAssets]);

  const checkExistingLogo = () => {
    for (const [channelName, channelPosts] of Object.entries(posts)) {
      for (const post of channelPosts) {
        logger.log("info:CampaignCreatePreviews:checkExistingLogo", "Updating post with logo", {
          channelName,
          post
        });

        const { channel, postNumber } = post;
        const { userName } = userProfile;

        checkLogoRequired(
          post,
          companyLogo,
          channel,
          postNumber,
          isReleased,
          userName,
          tbCampaignId
        );
      }
    }
  };

  const checkSpotifyClipGenerator = () => {
    const existingSpotifyErrors = adErrors?.filter(({ inputKey }) =>
      inputKey.includes("-spotify-audio")
    );

    if (posts.spotify) {
      // TODO only show this error before activating the campaign
      // posts.spotify.forEach(({ audioData, postNumber }) => {
      //   if (!audioData?.url) {
      //     return Actions.setAdErrors({
      //       inputKey: `${postNumber}-spotify-audio`,
      //       hasError: true,
      //       errorMessage: `${t("Spotify requires a mandatory audio clip")}`
      //     });
      //   }
      //   return Actions.removeAdErrors(`${postNumber}-spotify-audio`);
      // });
    } else {
      if (existingSpotifyErrors) {
        existingSpotifyErrors.forEach(({ inputKey }) => {
          Actions.removeAdErrors(inputKey);
        });
      }
    }
  };

  let showDownloadVideo = false;
  if (selectedPost) {
    showDownloadVideo = selectedPreviewChannel === "tiktok" && selectedPost.videoData;
  }

  let mediaAsssetsLabFlag = false;
  posthogInstance?.setPersonPropertiesForFlags({ email: userProfile?.email });

  posthogInstance?.onFeatureFlags(function () {
    if (posthogInstance.isFeatureEnabled("media-assets-lab")) {
      mediaAsssetsLabFlag = true;
    }
  });

  // It will render the button if the orga has the feature enabled
  // and if the page does not have a token
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");
  const canRenderSharedLinkButton = ORGAS_WITH_LINK_TO_PREVIEW.includes(orgaId) && !token;

  return (
    <>
      {mediaAsssetsLabFlag && (
        <MediaAssetsLab
          isVisible={showMediaAssetsLabModal}
          campaignId={tbCampaignId}
          isReleased={isReleased}
        />
      )}

      {!showMediaAssetsLabModal && (
        <SC.PreviewsWrapper>
          {showStartingDatePanel && startingDate ? (
            <CSSTransition
              classNames="statingDate"
              unmountOnExit
              in={showStartingDatePanel && startingDate}
              timeout={300}
            >
              <SC.StartingDateWrapper>
                <SC.StartingDatePanel>
                  <CampaignCreateStartDateEditor
                    textBeforeTime={t("Your campaign goes into")}
                    textAfterTime={t("online.")}
                    startingDate={startingDate}
                    changeStartingDate={changeStartingDate}
                    setCampaignWaitingForApproval={setCampaignWaitingForApproval}
                    secondsLeft={secondsLeft}
                    setSecondsLeft={setSecondsLeft}
                  />
                </SC.StartingDatePanel>
              </SC.StartingDateWrapper>
            </CSSTransition>
          ) : (
            <></>
          )}

          <SC.PreviewModeSwitchWrapper>
            {showDeviceSwitch && (
              <Switch
                isLeft={!isMobileView}
                switchAction={switchPreviewMode}
                leftOption={{
                  Icon: WebIcon,
                  isStroke: true,
                  label: t("Web View")
                }}
                rightOption={{
                  Icon: MobileIcon,
                  isStroke: true,
                  label: t("Mobile View")
                }}
              />
            )}
          </SC.PreviewModeSwitchWrapper>

          <SC.PostsWrapper>
            <SC.CampaignCreateSidebarChannelsWrapper>
              {mediaAsssetsLabFlag && !loading && (
                <Button
                  variant="secondary"
                  onClick={() => ActionsMediaAssetsLab.toggleModal()}
                  text="Media Assets Lab"
                  direction="row-reverse"
                  icon={<ExpandIcon />}
                  style={{ width: "100%", marginBottom: "10px" }}
                />
              )}

              <SideBarChannels
                selectedPreviewChannel={
                  showLeadForm ? "leadForm" : showAts ? "ats" : selectedPreviewChannel
                }
                changePreviewChannel={changePreviewChannel}
                clientView={clientView}
                hasAts={hasAts}
                setShowAts={switchToQualificationQuestions}
                setShowLeadForm={switchToLeadForm}
                jobPageLink={jobPageLink}
              />

              <SC.ActionButtonSection>
                <SC.ActionButton onClick={handlePrint} disabled={!posts}>
                  <PdfFileIcon size={24} />
                  {isPrinting ? <Loader size={24} /> : <div>{t("Save as PDF")}</div>}
                </SC.ActionButton>

                {showDownloadVideo ? (
                  isGeneratingMedia ? (
                    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                      <Loader size={35} />
                    </div>
                  ) : (
                    <SC.ActionButton onClick={generateMedia} disabled={!posts}>
                      <SaveIcon style={{ marginRight: "6px", width: "18px", height: "18px" }} />
                      <div style={{ marginTop: "1px" }}>{t("Download video")}</div>
                    </SC.ActionButton>
                  )
                ) : (
                  <></>
                )}

                {canRenderSharedLinkButton ? (
                  <SC.ActionButton onClick={handleCopyLink} disabled={!posts}>
                    <SharePreviewIcon style={{ padding: "3px 0px" }} />
                    <div style={{ marginTop: "1px" }}>{t("Share")}</div>
                  </SC.ActionButton>
                ) : (
                  <></>
                )}
              </SC.ActionButtonSection>
            </SC.CampaignCreateSidebarChannelsWrapper>
            <SC.CampaignCreatePostEditorWrapper>
              {selectedPost && (
                <div style={{ minHeight: "600px" }}>
                  <CampaignCreatePostEditor
                    selectedPreviewChannel={selectedPreviewChannel}
                    postData={selectedPost}
                    selectedChannelCampaignData={selectedChannelCampaignData}
                    channelData={editableChannelData}
                    selectedPostNumber={selectedPostNumber}
                    channelPosts={posts[selectedPreviewChannel]}
                    mobile={isMobileView}
                    isExternal={isExternal}
                    isReleased={isReleased}
                    editable={editable}
                    userName={userProfile?.userName}
                    clientView={clientView}
                    selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
                    setSelectedCreativeIndexToEdit={setSelectedCreativeIndexToEdit}
                    orgaId={orgaId}
                    orgaLinkedInPageID={orgaLinkedInPageID}
                    adsetId={tbAdsetId}
                    campaignId={tbCampaignId}
                    showAts={showAts}
                    hasAts={hasAts}
                    showLeadForm={showLeadForm}
                    jobPageLink={jobPageLink}
                    showLinkEditor={showLinkEditor}
                    campaignLanguage={campaignLanguage}
                    companyId={campaignData?.companyId || null}
                  />
                </div>
              )}

              {!selectedPost && (
                <div style={{ minHeight: "600px" }}>
                  <PostEditorSkeleton />
                </div>
              )}

              {!showAts && !showLeadForm && posts && !isExternal && (
                <CampaignCreatePostSelector
                  selectedPreviewChannel={selectedPreviewChannel}
                  channelPosts={posts[selectedPreviewChannel]}
                  addPost={handleAddPost}
                  removePost={handleRemovePost}
                  selectedPostNumber={selectedPostNumber}
                  setSelectedPostNumber={setSelectedPostNumber}
                  editable={editable}
                  allowMultiplePostsPerChannel={allowMultiplePostsPerChannel}
                  maxPostPerChannel={maxPostPerChannel}
                  clientView={clientView}
                />
              )}
            </SC.CampaignCreatePostEditorWrapper>
            <SC.CampaignCreateRightPanelWrapper>{children}</SC.CampaignCreateRightPanelWrapper>
          </SC.PostsWrapper>
          <SC.PrintViewWrapper>
            <PrintAdpreview posts={posts} channelsData={channelsData} contentRef={contentRef} />
          </SC.PrintViewWrapper>
          <div id="right-side-portal" />
        </SC.PreviewsWrapper>
      )}
    </>
  );
};

export default withRouter(
  withLDConsumer()(
    withRefluxStore(
      CampaignCreatePreviews,
      [
        CampaignCreationStore,
        PreviewStore,
        MediaAssetsLabStore,
        TempDraftCreationStore,
        PosthogStore
      ],
      [
        "loading",
        "posts",
        "channelsData",
        "released",
        "userProfile",
        "allowMultiplePostsPerChannel",
        "maxPostPerChannel",
        "jobPageLink",
        "selectedPostNumber",
        "companyLogo",
        "adErrors",
        "showMediaAssetsLabModal",
        "posthogInstance",
        "templateDataToDownload",
        "locale",
        "campaignData"
      ]
    )
  )
);
